import { Injectable } from "@angular/core";
import { EzoomApiProvider } from "./ezoom-api";

@Injectable()
export class ReservesProvider {
    constructor(public api: EzoomApiProvider) {}

    public getReserves(type: string, page: number, sequency: string) {
        return new Promise((resolve, reject) => {
            this.api
                .get("reserves", { type: type, page: page, sequency: sequency })
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                });
        });
    }

    public getFreePools() {
        return new Promise((resolve, reject) => {
            this.api.get("reserves/pools", {}).subscribe((response: any) => {
                if (response.status) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            });
        });
    }

    public getPool(id: any) {
        return new Promise((resolve, reject) => {
            this.api.get("pools/" + id, {}).subscribe((response: any) => {
                if (response.status) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            });
        });
    }

    public reservePool(id: any, params: any = {}) {
        return new Promise((resolve, reject) => {
            this.api
                .post("pools/reserve/" + id, params)
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                });
        });
    }

    public getSalons() {
        return new Promise((resolve, reject) => {
            this.api.get("reserves/get/salons").subscribe((response: any) => {
                if (response.status) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            });
        });
    }

    public getSalonDetails(id: any, sequency: string) {
        return new Promise((resolve, reject) => {
            this.api
                .get("salons/" + id, { sequency: sequency })
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                });
        });
    }

    public getCoworkingDetails(id: any) {
        return new Promise((resolve, reject) => {
            this.api
                .get("coworking/get/" + id)
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                });
        });
    }

    public checkSalonAvailability(id: any, date: string) {
        return new Promise((resolve, reject) => {
            this.api
                .get("salons/check-availability", { id: id, date: date })
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                });
        });
    }

    public checkCoworkingAvailability(id: any, date: string) {
        return new Promise((resolve, reject) => {
            this.api
                .get("coworking/check-availability", { id: id, date: date })
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                });
        });
    }

    public reserveSalon(data: any) {
        return new Promise((resolve, reject) => {
            this.api.post("salons/reserve", data).subscribe((response: any) => {
                if (response.status) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            });
        });
    }

    public reserveCoworking(data: any) {
        return new Promise((resolve, reject) => {
            this.api.post("coworking/reserve", data).subscribe((response: any) => {
                if (response.status) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            });
        });
    }

    public confirmReserve(token: any) {
        return new Promise((resolve, reject) => {
            this.api
                .post("salons/finish", { token: token })
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                });
        });
    }

    public getCoworkingRooms() {
        return new Promise((resolve, reject) => {
            this.api.get("reserves/get/coworking").subscribe((response: any) => {
                if (response.status) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            });
        });
    }

    public getKiosks() {
        return new Promise((resolve, reject) => {
            this.api.get("reserves/get/kiosks").subscribe((response: any) => {
                if (response.status) {
                    console.log(response.data);
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            });
        });
    }

    public getKiosk(id: any, sequency: string) {
        return new Promise((resolve, reject) => {
            this.api
                .get("kiosks/" + id, { sequency: sequency })
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                });
        });
    }

    public reserveKiosk(id: any, params: any = {}) {
        return new Promise((resolve, reject) => {
            this.api
                .post("kiosks/reserve/" + id, params)
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                });
        });
    }

    public getFitness() {
        return new Promise((resolve, reject) => {
            this.api
                .get("reserves/get/fitness", {})
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                });
        });
    }

    public getSchools() {
        return new Promise((resolve, reject) => {
            this.api
                .get("reserves/get/schools", {})
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                });
        });
    }

    public getSchool(id: any) {
        return new Promise((resolve, reject) => {
            this.api.get("schools/" + id, {}).subscribe((response: any) => {
                if (response.status) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            });
        });
    }

    public getActivity(id: any) {
        return new Promise((resolve, reject) => {
            this.api.get("gym/" + id, {}).subscribe((response: any) => {
                if (response.status) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            });
        });
    }

    public reserveActivity(id: any, params: any = {}) {
        return new Promise((resolve, reject) => {
            this.api
                .post("gym/reserve/" + id, params)
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                });
        });
    }

    public reserveSchool(id: any, params: any = {}) {
        return new Promise((resolve, reject) => {
            this.api
                .post("schools/reserve/" + id, params)
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                });
        });
    }

    public cancelReserve(id, type) {
        return new Promise((resolve, reject) => {
            this.api
                .post("reserves/cancel", { id: id, type: type })
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/reserves.ts